import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const InteractiveFrameViewer = () => {
    const { id } = useParams();
    const [frame, setFrame] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFrame = async () => {
            try {
                const res = await fetch(`/api/public/frames/${id}`);
                const data = await res.json();
                if (data.success) {
                    setFrame(data.frame);
                } else {
                    setError('Frame no encontrado.');
                }
            } catch (err) {
                console.error(err);
                setError('Ocurrió un error al cargar el diseño.');
            } finally {
                setLoading(false);
            }
        };
        fetchFrame();
    }, [id]);

    if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>Cargando diseño...</div>;
    if (error) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif', color: 'red' }}>{error}</div>;
    if (!frame) return null;

    // We render the HTML raw. Since it's autonomous, it takes full width/height by default or the specified ones.
    const width = frame.frame_width && frame.frame_width.trim() !== '' ? frame.frame_width : '100vw';
    const height = frame.frame_height && frame.frame_height.trim() !== '' ? frame.frame_height : '100vh';

    return (
        <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0, overflow: 'auto', background: 'transparent' }}>
            <div style={{ width, minHeight: height, margin: '0 auto', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: frame.html_content }} />
        </div>
    );
};

export default InteractiveFrameViewer;
